import https from "../../axios";
import { BaseResponse } from "../../db/response";
import normalizeBaseResponse from "../../utils/responseHandler";
import errorHandler from "../../utils/errorHandler";

interface LoginParams {
  username: string;
  password: string;
  rememberMe?: boolean;
}

export interface LoginResponse extends BaseResponse {
  data?: {
    accessToken: string;
    refreshToken: string;
    expiresIn: number;
    sessionId: string;
    tokenType: string;
    activeRole?: string;
    availableRoles?: string[];
  };
}

export const realcheckLogin = async (
  params: LoginParams,
): Promise<LoginResponse> => {
  try {
    const response = await https.post("/v1/auth/login", params);
    return {
      ...normalizeBaseResponse(response.data),
      data: response.data?.data,
    };
  } catch (error) {
    return errorHandler(error);
  }
};

interface LogoutParams {
  sessionId: string;
  refreshToken?: string;
}

export interface LogoutResponse extends BaseResponse {
  data?: {
    message: string;
    terminatedAt: string;
  };
}

export const doLogout = async (
  params: LogoutParams,
  accessToken?: string,
): Promise<LogoutResponse> => {
  try {
    const headers: Record<string, string> = {};
    // Add Authorization header if access token is provided (required by swagger)
    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`;
    }
    
    const response = await https.post("/v1/auth/logout", params, { headers });
    return {
      ...normalizeBaseResponse(response.data),
      data: response.data?.data,
    };
  } catch (error) {
    return errorHandler(error);
  }
};
